import { useState } from 'react';
import { trackEvent } from '../../../utils/analytics';

interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const [menuOpen, setMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    setMenuOpen(false);
    if (id === 'calendar') {
      trackEvent('calendar_click');
    }
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || menuOpen ? 'bg-[#0a0a0a] shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
          <img
            src="https://public.readdy.ai/ai/img_res/2646c0d9-40fb-45bd-88c3-566ccc6efb39.png"
            alt="ProtectWhatsMine Logo"
            className="h-9 w-9 object-contain"
          />
          <span className="text-base sm:text-xl font-bold text-white leading-tight">ProtectWhatsMine</span>
        </div>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-8">
          <button onClick={() => scrollToSection('trifecta')} className="text-sm font-medium text-gray-100 hover:text-white transition-colors cursor-pointer whitespace-nowrap">How It Works</button>
          <button onClick={() => scrollToSection('trifecta')} className="text-sm font-medium text-gray-100 hover:text-white transition-colors cursor-pointer whitespace-nowrap">About</button>
          <button onClick={() => scrollToSection('calendar')} className="text-sm font-medium text-gray-100 hover:text-white transition-colors cursor-pointer whitespace-nowrap">Get Protected</button>
          <button onClick={() => scrollToSection('calendar')} className="text-sm font-medium text-gray-100 hover:text-white transition-colors cursor-pointer whitespace-nowrap">Contact</button>
          <button onClick={() => scrollToSection('calendar')} className="px-5 py-2.5 bg-[#dc2626] text-white text-sm font-bold rounded-md hover:bg-[#b91c1c] transition-colors cursor-pointer whitespace-nowrap">
            Schedule Strategy Call
          </button>
        </div>

        {/* Mobile right side */}
        <div className="flex md:hidden items-center gap-3">
          <button
            onClick={() => scrollToSection('calendar')}
            className="px-3 py-2 bg-[#dc2626] text-white text-xs font-bold rounded-md hover:bg-[#b91c1c] transition-colors cursor-pointer whitespace-nowrap"
          >
            Schedule Call
          </button>
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="w-9 h-9 flex items-center justify-center text-white cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile dropdown menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#0a0a0a] border-t border-[#2a2a2a] px-4 pb-4 flex flex-col gap-1">
          <button onClick={() => scrollToSection('trifecta')} className="text-left py-3 text-sm font-medium text-gray-100 hover:text-white border-b border-[#1a1a1a] cursor-pointer">How It Works</button>
          <button onClick={() => scrollToSection('trifecta')} className="text-left py-3 text-sm font-medium text-gray-100 hover:text-white border-b border-[#1a1a1a] cursor-pointer">About</button>
          <button onClick={() => scrollToSection('calendar')} className="text-left py-3 text-sm font-medium text-gray-100 hover:text-white border-b border-[#1a1a1a] cursor-pointer">Get Protected</button>
          <button onClick={() => scrollToSection('calendar')} className="text-left py-3 text-sm font-medium text-gray-100 hover:text-white cursor-pointer">Contact</button>
        </div>
      )}
    </nav>
  );
}
